import PropTypes from "prop-types";
import styles from "./Button.module.css";

/**
 * Dugme sa razlogom zašto je onemogućeno.
 *
 * Povod (Goran, 25.08.2026): „Ne da mi da obrišem praznu tabelu! Uneo sam
 * ključ, a potom probao da je bacim u đubre, a to znači da kliknem po
 * onemogućenom dugmetu." Onemogućeno dugme ne kaže ništa — korisnik ne zna da
 * li je zabranjeno, pokvareno, ili on nešto nije uradio.
 *
 * `title` na samom dugmetu ovde ne pomaže: onemogućeni element ne prima
 * događaje miša, pa se oblačić po pravilu ni ne pojavi. Zato razlog nosi
 * OMOTAČ, koji ih prima.
 *
 * Omotač se dodaje samo kad je dugme stvarno onemogućeno i kad razlog postoji —
 * inače se iscrtava golo dugme, kao i pre.
 */
const Button = ({
  buttonType = "contained",
  variant = "primary",
  expand = "block",
  className,
  disabledReason,
  ...props
}) => {
  const dugme = (
    <button
      type="button"
      className={`${styles.button} ${styles[buttonType]} ${styles[variant]} ${
        styles[expand]
      } ${className ?? ""}`}
      {...props}
    />
  );

  if (!props.disabled || !disabledReason) return dugme;

  return (
    <span
      className={`${styles.disabled_wrap} ${styles[expand] ?? ""}`}
      title={disabledReason}
    >
      {dugme}
    </span>
  );
};

export default Button;

Button.propTypes = {
  buttonType: PropTypes.oneOf(["contained", "outlined", "text", "toggle"]),
  variant: PropTypes.oneOf(["primary", "secondary", "danger"]),
  expand: PropTypes.oneOf(["full", "block"]),
  /** Zašto je dugme onemogućeno. Prikazuje se kao oblačić nad omotačem. */
  disabledReason: PropTypes.string,
};
